import { ICustomValue } from '@mfe-types/field';

import { formatStringWithPlusSign } from './format';

export const incrementValue = (value: string | number, increment = 1) => {
    let formattedValue = formatStringWithPlusSign(value);
    if (isNaN(formattedValue)) {
        formattedValue = 0;
    }
    return (formattedValue + increment).toString();
};

export const decrementValue = (value: string | number, increment = 1) => {
    const formattedValue = formatStringWithPlusSign(value);

    if (formattedValue - increment < 0) return;

    return (formattedValue - increment).toString();
};

export const matchLabelFromSelectionIfExists = (
    value: string | number,
    customValues: ICustomValue[],
): string | number | undefined => {
    const item = customValues.find((item: ICustomValue) => value === item?.value);
    return item?.label ?? value;
};

export const matchValueFromSelectionIfExists = (
    value: string | number,
    customValues: ICustomValue[],
): string | number | undefined => {
    const item = customValues.find((item: ICustomValue) => value === item?.label);
    return item?.value ?? value;
};

export const matchValueFromManualInputIfExists = (
    value: string,
    customValues: ICustomValue[],
): string => {
    if (value && value.length > 1) {
        const previousValue = value.slice(0, -1);
        const lastValue = value.slice(-1);
        const item = customValues.find((item: ICustomValue) => item.label === previousValue);
        return (item && `${item.value}${lastValue}`) ?? value;
    }
    return value;
};
